/**
 * Formats user input into normalized digits-only string for Turkish Identity Number (TCKN).
 */
export const normalizeIdentityNumber = (value: string): string => {
  return value.replace(/\D/g, '').slice(0, 11);
};

/**
 * Validates a Turkish Republic Identity Number (T.C. Kimlik No) format according to official rules:
 * - Exactly 11 digits
 * - Cannot start with '0'
 * - 10th digit = ((7 * sum(1st, 3rd, 5th, 7th, 9th digits)) - sum(2nd, 4th, 6th, 8th digits)) mod 10
 * - 11th digit = sum(1st..10th digits) mod 10
 *
 * @returns null if valid, or error message string if invalid.
 */
export const validateIdentityNumberFormat = (
  value?: string | null
): string | null => {
  if (!value || !value.trim()) {
    return 'T.C. Kimlik Numarası zorunludur.';
  }

  const clean = value.trim();

  if (!/^[1-9]\d{10}$/.test(clean)) {
    return 'T.C. Kimlik Numarası 11 haneli rakamlardan oluşmalı ve 0 ile başlayamaz.';
  }

  const digits = clean.split('').map(Number);
  const oddSum = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
  const evenSum = digits[1] + digits[3] + digits[5] + digits[7];

  let digit10 = ((oddSum * 7) - evenSum) % 10;
  if (digit10 < 0) digit10 += 10;

  if (digits[9] !== digit10) {
    return 'Geçersiz T.C. Kimlik Numarası.';
  }

  let sum10 = 0;
  for (let i = 0; i < 10; i++) {
    sum10 += digits[i];
  }

  if (digits[10] !== sum10 % 10) {
    return 'Geçersiz T.C. Kimlik Numarası.';
  }

  return null;
};
